namespace Gordic.Uda.WebControls {
    let gcontent = Decorators.gcontent;

    /**
     * Test bez cs
     *
     * @author Jindřich Vácha
     * @since 480.2.0.0
     */
    @gcontent
    export class TestBezCs extends GContentBase {

        taskId = "actTestBezCs";

        /**
         * Definice formuláře
         */
        public onContentReady(): void {

            let that = this;

            console.log("Gordic.Uda.WebControls.actTestBezCs.onContentReady", this);

        } // onContentReady

    } // cls
} // ns